export interface FooterUrls {
  urlCgv: string;
  urlMentionsLegales: string;
  urlPolitiqueConf: string;
  urlUtilConf: string;
}

export const EMPTY_FOOTER_URLS: FooterUrls = {
  urlCgv: '',
  urlMentionsLegales: '',
  urlPolitiqueConf: '',
  urlUtilConf: '',
};
